var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-size"},[(_vm.tabName === 'Relatórios')?_c('div',[_c('Relatorios')],1):_vm._e(),(_vm.tabName === 'Lista de E-mails')?_c('div',[_c('ListaEmails')],1):_vm._e(),(_vm.tabName === 'Etiquetas')?_c('div',[_c('Etiquetas')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }